export default __webpack_public_path__ + "static/media/plan.d504f8f9.svg";